import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { withSSO } from '@catapultxos/sso-auth';

import store from '../state/store';
import ApplicationLayout from '../layouts/ApplicationLayout';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ApplicationLayout />
      </BrowserRouter>
    </Provider>
  );
}

export default withSSO({
  redirectUrl: process.env.REACT_APP_SSO_UI_LOGIN_URL,
})(App);
